var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-header",style:({cursor:_vm.is_back ? 'pointer':''}),on:{"click":_vm.redit}},[_c('div',{staticClass:"my-header-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticStyle:{"flex":"1","margin-left":"10px"}},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }